<template>
  <v-data-table
    v-if="applications && applications[0]"
    v-bind="$attrs"
    :items="applications"
    :headers="headers"
    :pagination.sync="pagination"
    @update:pagination="e => $emit('paginate', e)"
    must-sort
  >
    <template slot="items" slot-scope="{ item }">
      <td>{{ item.id }}</td>
      <td v-if="item.opportunity">{{ item.opportunity.organization.name }}</td>
      <td v-if="item.opportunity">
        <router-link :to="`/opportunities/${item.opportunity.id}`">
          {{ item.opportunity.name }}
        </router-link>
      </td>
      <td>{{ item.status }}</td>
      <td>{{ new Date(item.createdAt) | date('HH:mm MMM do ’yy') }}</td>
      <td>{{ new Date(item.updatedAt) | date('HH:mm MMM do ’yy') }}</td>
      <td v-if="item.profile && item.eligibility">
        <v-tooltip
          v-if="item.eligibility && item.eligibility.eligible === true"
          color="grey darken-3"
          left
        >
          <v-btn
            :to="`/eligibilities?profile=${item.profile.id}&opportunity=${item.opportunity.id}`"
            slot="activator"
            color="green"
            small
            flat
            fab
          >
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
          <span>Still qualifies</span>
        </v-tooltip>
        <v-tooltip
          v-if="item.eligibility && item.eligibility.eligible === false"
          color="grey darken-3"
          left
        >
          <v-btn
            :to="`/eligibilities?profile=${item.profile.id}&opportunity=${item.opportunity.id}`"
            slot="activator"
            color="warning"
            small
            flat
            fab
          >
            <v-icon>mdi-alert-outline</v-icon>
          </v-btn>
          <span>No longer qualifies</span>
        </v-tooltip>
      </td>
      <td class="text-xs-right">
        <v-tooltip left color="grey darken-3">
          <v-btn
            slot="activator"
            :to="`/applications/${item.id}`"
            color="secondary"
            class="ma-0"
            small
            flat
            fab
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <span>View</span>
        </v-tooltip>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  // So $attrs is available
  inheritAttrs: false,

  props: {
    applications: { type: Array, require: true },
  },

  data() {
    return {
      // Table Configuration
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Organization', value: 'opportunity.organization.name' },
        { text: 'Opportunity', value: 'opportunity.name' },
        { text: 'Status', value: 'status' },
        { text: 'Applied', value: 'createdAt' },
        { text: 'Last updated', value: 'updatedAt' },
        { text: 'Eligible', sortable: false, align: 'right' },
        { text: 'Actions', sortable: false },
      ],
      pagination: { sortBy: 'updated_at', descending: true, rowsPerPage: 25 },
    }
  },
}
</script>
